var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompassNorthWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55785 20.3776L11.9549 11.0946C11.9589 11.0862 11.9653 11.079 11.9733 11.074C11.9813 11.0691 11.9905 11.0664 11.9999 11.0664C12.0092 11.0664 12.0184 11.0691 12.0264 11.074C12.0344 11.079 12.0408 11.0862 12.0449 11.0946L16.4419 20.3776C16.4461 20.3868 16.4475 20.397 16.4458 20.407C16.4441 20.417 16.4394 20.4262 16.4324 20.4334C16.4253 20.4407 16.4163 20.4457 16.4063 20.4476C16.3964 20.4496 16.3862 20.4486 16.3769 20.4446L12.0199 18.5096C12.0135 18.5069 12.0067 18.5054 11.9999 18.5054C11.993 18.5054 11.9862 18.5069 11.9799 18.5096L7.62285 20.4456C7.61356 20.4496 7.60327 20.4506 7.59336 20.4486C7.58345 20.4466 7.57438 20.4417 7.56734 20.4344C7.5603 20.4272 7.55562 20.418 7.55393 20.408C7.55224 20.398 7.5536 20.3868 7.55785 20.3776Z",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.5V18.5",
    stroke: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.5V3.68C10.5 3.63 10.567 3.611 10.593 3.655L13.407 8.345C13.433 8.389 13.5 8.37 13.5 8.319V3.5",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassNorthWhite);
export default __webpack_public_path__ + "static/media/compass-north-white.8fb8b1614c7731a62d4f97362bc02446.svg";
export { ForwardRef as ReactComponent };